module.exports = __webpack_public_path__ + "static/media/home-rewards-top.8fee6f5a.png";